import { AxiosResponse } from 'axios';
import { stringify } from 'qs';

import { axiosInstance } from './axios.config';
import { ResponseREST, ResponseSearch } from './response.type';

export interface QueryParamProductConfig {
  filter?: {
    searchKeyword: string;
  };
  paginate?: {
    offset: number;
    limit: number;
  };
}

interface ResponseSuccessGetSearch extends ResponseREST {
  data: Array<ResponseSearch>;
  paginate: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const getProductConfig = async (
  idWasteCategory: number,
  params: QueryParamProductConfig
): Promise<ResponseSuccessGetSearch> => {
  return axiosInstance
    .get(`api/stock-waste-document-mobile/get-product-config-mobile/${idWasteCategory}`, {
      params,
      paramsSerializer: (param) => stringify(param)
    })
    .then((res: AxiosResponse<ResponseSuccessGetSearch>) => res.data);
};
